import {
    countNonEmptyProperties,
    createFilterHash,
    parseFilterString,
    updateObjectValues,
    getCurrentURLHashQuery,
    AdvanceFilterOptionNew,
    returnClearedFiltersObject,
    ListOfMultiValuedFilterType,
} from './helper';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Button } from '@monavate/ui-core';
import FiltersBladeModal from './components/FiltersBladeModal/FiltersBladeModal';
import FastFilters from './components/FastFilters/FastFilters';
import { isArray } from 'lodash';

const Wrapper = styled.div`
    width: 100%;
`;

const TopContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const BottomContainer = styled.div`
    width: 100%;
`;

const ChildrenWrapperLeft = styled.div``;
const LeftPanelWrapper = styled.div`
    display: flex;
`;
const RightPanelWrapper = styled.div<{ gap?: number }>`
    display: flex;
    align-items: center;
    gap: ${(props) => (props.gap ? `${props.gap}px` : '0')};
`;
const ChildrenWrapperRight = styled.div``;

const ButtonsGroupContainer = styled.div`
    display: inline-flex;
    align-items: flex-start;
    gap: 16px;
`;

interface FiltersAdvancedProps {
    headersChildrenLeft?: React.ReactNode;
    headersChildrenRight?: React.ReactNode;
    bladeModalHeaderDescription: string;
    onFilterUpdatesCallback: (filters: any) => void;
    onFilterResetCallback?: () => void;
    hideFilterButton?: boolean;
    buttonsGap?: number;
    buttonsContainerStyle?: any;
    validationScheme: any;
    options: AdvanceFilterOptionNew[];
}

const FiltersAdvanced: React.FC<FiltersAdvancedProps> = ({
    headersChildrenLeft,
    headersChildrenRight,
    onFilterUpdatesCallback,
    bladeModalHeaderDescription,
    hideFilterButton,
    onFilterResetCallback,
    buttonsGap,
    buttonsContainerStyle,
    validationScheme,
    options,
}) => {
    const [isBladeModalOpen, setIsBladeModalOpen] = useState(false);
    const [appliedFiltersCount, setAppliedFiltersCount] = useState(0);
    const [appliedFilters, setAppliedFilters] = useState<Record<string, any>>({});

    const updateURLWithFilter = (filterObject: Record<string, any>) => {
        const filterString = createFilterHash(filterObject);
        const newUrl =
            window.location.href.split('#')[0] + (filterString ? `#${filterString}` : '');
        window.history.pushState({ path: newUrl }, '', newUrl);
    };

    useEffect(() => {
        const hash = getCurrentURLHashQuery();
        const filtersFromUrl = parseFilterString(hash, options);
        let filterObject: Record<string, any> = {};
        if (options) {
            options.forEach((option) => {
                filterObject[option.name] = option.defaultValue;
            });
            const updatedFilterObj = updateObjectValues(filterObject, filtersFromUrl);
            setAppliedFilters(updatedFilterObj);
            onFilterUpdatesCallback(updatedFilterObj);
        }
    }, []);

    useEffect(() => {
        const filters = appliedFilters;
        const count = countNonEmptyProperties(filters);
        setAppliedFiltersCount(count);
        updateUrl(appliedFilters);
    }, [appliedFilters]);

    const updateUrl = (obj?: Record<string, any>) => {
        const filters = obj || appliedFilters;
        // @ts-ignore
        updateURLWithFilter(filters);
    };

    const onClearFiltersButtonClickHandler = () => {
        const clearedFilters = returnClearedFiltersObject(options);
        setAppliedFilters(clearedFilters);
        onFilterUpdatesCallback(clearedFilters);
    };
    const onFilterButtonClickHandler = () => {
        setIsBladeModalOpen(true);
    };
    const onModalCancelButtonClickHandler = () => {
        setIsBladeModalOpen(false);
    };

    const removeFilterHandlerFromFastFilters = (filter: Record<string, any>, value: any) => {
        const newObj = { ...appliedFilters };
        const fieldType = filter.option.fieldType;
        // check if it is not multiselect fieldType
        if (ListOfMultiValuedFilterType.indexOf(fieldType) === -1) {
            // @ts-ignore
            newObj[filter.name] = '';
        } else {
            if (isArray(value) && value?.length > 0) {
                newObj[filter.name] = [];
            } else {
                const removeValueFormList = filter.value.filter((item: any) => item !== value);
                if (removeValueFormList.length > 0) {
                    newObj[filter.name] = removeValueFormList;
                } else {
                    // @ts-ignore
                    newObj[filter.name] = '';
                }
            }
        }
        setAppliedFilters(newObj);
        onFilterUpdatesCallback(newObj);
    };
    const onApplyFiltersFromModalCallback = (filters: Record<string, any>) => {
        // @ts-ignore
        const updatedFilterObj = updateObjectValues(appliedFilters, filters);
        setAppliedFilters(updatedFilterObj);
        onFilterUpdatesCallback(updatedFilterObj);
        setIsBladeModalOpen(false);
    };

    return (
        <Wrapper>
            <TopContainer>
                <LeftPanelWrapper>{headersChildrenLeft}</LeftPanelWrapper>
                <RightPanelWrapper gap={buttonsGap} style={buttonsContainerStyle}>
                    {appliedFiltersCount > 0 && (
                        <Button
                            style={{ padding: '8px 16px', border: 'none', marginRight: 16 }}
                            viewType="default"
                            handleClick={onClearFiltersButtonClickHandler}
                            dataTestId="button-clear-filters"
                        >
                            <span className="material-symbols-sharp">close</span>
                            Clear filters
                        </Button>
                    )}
                    {!hideFilterButton && (
                        <Button
                            style={{ padding: '8px 16px' }}
                            viewType="default"
                            handleClick={onFilterButtonClickHandler}
                            dataTestId="button-open-filters"
                        >
                            <span className="material-symbols-sharp">filter_list</span>
                            Filter {appliedFiltersCount > 0 ? `(${appliedFiltersCount})` : ''}
                        </Button>
                    )}

                    <div>{headersChildrenRight}</div>
                </RightPanelWrapper>
            </TopContainer>
            {appliedFiltersCount > 0 && (
                <BottomContainer>
                    <FastFilters
                        filters={appliedFilters}
                        removeFilter={removeFilterHandlerFromFastFilters}
                        options={options}
                    />
                </BottomContainer>
            )}
            <FiltersBladeModal
                bladeModalHeaderDescription={bladeModalHeaderDescription}
                isOpen={isBladeModalOpen}
                appliedFiltersCount={appliedFiltersCount}
                onFilterResetCallback={onFilterResetCallback}
                onModalCancelButtonClickHandler={onModalCancelButtonClickHandler}
                onApplyFiltersFromModalCallback={onApplyFiltersFromModalCallback}
                appliedFilters={appliedFilters}
                validationScheme={validationScheme}
                options={options}
            />
        </Wrapper>
    );
};

export default FiltersAdvanced;
